import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';

@Component({
  standalone: true,
  selector: 'filter-chip',
  templateUrl: './filter-chip.component.html',
  styleUrls: ['./filter-chip.component.scss'],
  imports: [CommonModule]
})
export class FilterChipComponent {

  IMAGE_URLS = IMAGE_URLS;

  readonly hasFilterTitle = computed(() => !!this.filterTitle());

  filterTitle = input<string>('');

  // Update output to use Angular 20 output() function
  removeFilter$ = output<void>();


  onRemoveFilter() {
    this.removeFilter$.emit();
  }
}

